import { useRollbar } from '@rollbar/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { pageTypes } from 'common/constants/pageTypes'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { BaseEntityInterface } from 'common/types/entities/EntityInterface'
import { EntityInnerItemInterface } from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { createPopupFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/popup/create-popup'
import { createPopupWebinarRegistrationFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/popup/create-popup-webinar-registration'
import { createPopupWithAgreementFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/popup/create-popup-with-agreement'
import { usePage } from 'client/store'
import {
  removePopup as removePopupAction,
  toggleActivePopup,
} from 'client/store/management/managementActions'
import { createPopupStructure as createPopupStructureAction } from 'client/store/page/pageActions'
import pageSelectors from 'client/store/page/pageSelectors'
import BlueButton from '../../../BlueButton'
import { ManagementEmpty } from './management-empty'
import { ManagementItem } from './management-item'
import { ManagementAddItemUi } from './ui/management-add-item-ui'

export const PopupManagement = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const rollbar = useRollbar()

  const popups = usePage(pageSelectors.getPopupEntities)
  const pageType = usePage(pageSelectors.getPageType)
  const pageLocale = usePage(pageSelectors.getPageLocale)
  const nextPopupNumber = usePage(pageSelectors.getNextPopupNumber)

  const showPopup = (id: string) => dispatch(toggleActivePopup(id))
  const removePopup = (id: string) => dispatch(removePopupAction(id))
  const createPopupStructure = (structure: {
    [id: string]:
      | EntityInnerItemInterface
      | BaseEntityInterface
      | PopupInterface
      | OldEntityInterface
  }) => dispatch(createPopupStructureAction(structure))

  const createPopup = () => {
    let popup: {
      ascendantId: string
      structure: {
        [id: string]:
          | EntityInnerItemInterface
          | BaseEntityInterface
          | PopupInterface
          | OldEntityInterface
      }
    } | null = null
    if (pageType === pageTypes.offerPage || pageType === pageTypes.offerInner) {
      popup = createPopupWithAgreementFromLibrary(pageLocale)
    } else if (pageType === pageTypes.webinarRegistration) {
      popup = createPopupWebinarRegistrationFromLibrary(pageLocale)
    } else {
      popup = createPopupFromLibrary(pageLocale)
    }

    if (!popup) {
      return rollbar.error('Popup creation failed')
    }
    ;(popup.structure[popup.ascendantId] as PopupInterface).title =
      `Popup №${nextPopupNumber}`
    createPopupStructure(popup.structure)
    showPopup(popup.ascendantId)
  }

  return (
    <React.Fragment>
      {popups.map(popupEntity => (
        <ManagementItem
          id={popupEntity.id}
          title={
            popupEntity.type === EntityTypeEnum.Popup
              ? popupEntity.title
              : popupEntity?.options?.title
          }
          display={showPopup}
          remove={removePopup}
          key={popupEntity.id}
        />
      ))}
      {popups.length === 0 && <ManagementEmpty />}
      <ManagementAddItemUi>
        <BlueButton onClick={createPopup}>
          <span>{t('popup_management.add_popup')}</span>
        </BlueButton>
      </ManagementAddItemUi>
    </React.Fragment>
  )
}
